import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { CurrencyFormat } from "../../../components/FormattersTS";
import { Spin } from "antd";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const VehicleHireStatsWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     loadVehicleHireStats()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         loadVehicleHireStats();
    //     }
    // }, [props.date]);
    const refresh = () => {
        loadVehicleHireStats();
    };
    const loadVehicleHireStats = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/vehicle-hire-stats/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { vehicleHiresOnMarketCount, vehicleHiresAssignedCount, totalEstCost, avgEstCost } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), vehicleHiresOnMarketCount
                    ? _jsxs("h2", { className: "widget-value", children: [vehicleHiresAssignedCount, _jsxs("span", { className: "small", children: ["/", vehicleHiresOnMarketCount, " on market"] })] })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Vehicles hired", helpText: _jsx("p", { children: "The total number of vehicles hired from the SubTrux marketplace.  Hire requests that have not yet been accepted by a contractor are not included in this value." }) }) }), _jsx("div", { className: "widget-separator" }), (totalEstCost && avgEstCost)
                    ? _jsxs("h2", { className: "widget-value", children: [_jsx(CurrencyFormat, { value: totalEstCost }), _jsxs("span", { className: "small", children: ["\u00A0(avg: ", _jsx(CurrencyFormat, { value: avgEstCost }), ")"] })] })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Est. total cost", helpText: _jsx("p", { children: "An estimate of the cost for the above vehicle hire requests.  If all hires have been completed then this value is an accurate cost otherwise it's an estimate as specified in the request." }) }) })] }) }));
};
export default React.forwardRef(VehicleHireStatsWidget);
